const allVideos = [
	"XysLxkDGmzE",
	"hDOJgbXzCAs",
	"LQFBslRPKrc",
	"TgOLas5ca5A",
	"LvilVN2dPiM",
	"Y8rNNPVgpqM",
	"KErb2H3vkt0",
	"kXFFTxNQ1pU",
	"xDquTCuK1WI",
	"VljFBlm4Dwg",
	"LvBqLmn8Myg",
	"AwnQi-g2fYg",
	"7mn9VEkCxEw",
	"6D0y_dAMXbI",
	"tAznC9d21BI",
	"H3F0fZyyclI",
	"iZseBkDJEGc",
	"Sc-OUydN4Mw",
	"aGzQp38aJ7w",
	"skz7GpplIp8",
	"bqSRxVk0S6I",
	"JAA6GBJ3NWQ",
	"LSrKC6R2sFY",
	"HibH33B2XPs",
	"1lZTEjHsS4Y",
	"j3wDOxdwWC4",
	"30FR9IKuq_c",
	"WW3HSkJxUpo",
	"JMC62dSZGdA",
	"A4jnJqLbh2g",
	"fKFbnhcNnjE",
	"2lh7T3uL920",
	"GaYHgSmsz9k",
	"NKEkVoZNLY4",
	"y9_vvaU3yss",
	"JskG1QznPBo",
	"MzpaTN5dle0",
	"qG4DLc9Kotg",
	"yrsfyu9N0ps",
	"KLs6nPu0wWw",
	"NHah0WT8EtQ",
	"fSVvDhJRn_I",
	"Sq-YwZDVFJ8",
	"2t2fWSvEYVI",
	"TSXzbkztXVk",
	"0ScU-GVMSYU&",
	"3p8FP6enacY",
	"6Wld1EhHCN4",
	"ER-CvZJEmJE&",
	"LRd_ZaXMNGM",
	"YAsSbCK9UfI",
	"LSN4TyI2oSc",
	"TLIS8TJJnbk",
	"mGtg0WOdSWo",
	"wk768sdLzms",
	"BFeQViPOC0U",
	"Xnvun8kdsg8",
	"ifwMMHdXWFk",
	"DMVVy-ATZAw",
	"2Tn1H25y7lM",
	"qFkOsM1c8mM",
	"pNmJt76DVaI",
	"SXJl_orH3Yk",
	"ygyYZuJCoxg",
	"y4azqrpRNgU",
	"u6yYNNKtH94",
	"_Hh6TuOVCE0",
	"kl1WpuIP9Uo",
	"DXy5KJbWFuI",
	"ApyWU7YsEyc",
	"HKNxamrn5Js",
	"zWliGS2S4jY",
	"bx_mTU-XC-k",
	"WkzAQ7GBndg",
	"dEgajpKt2VM",
	"Q6AkSy5OU_k",
	"agGR19rACBg",
	"NfW1BDMkKfw",
	"FU6tgOJyQyo",
	"L7JqeAfQMu8",
	"KjX7hMwHyQQ",
	"Bo8iz1x2YnE",
	"JMaDoxGVpfg",
	"81-X6s1od0U",
	"3pVAYHDjhAM",
	"v4zW-ROpk9s",
	"uMyDhvk6v08",
	"4bKglE-DAIU",
	"sO4vKuBwfsI",
	"UJcYkFqc9U4",
	"sktqf3FDdbE",
	"K4W9JtjLxgI",
	"fLeDZjthHaA",
	"93SvEr1WNsc",
	"gd7b-NkIN3M",
	"GfwVGvpqj14",
	"r-d22Deac4o",
	"FoqIkb2HEhc",
	"ou36FBwtDe8",
	"Sb_MPWmTNQc",
	"TWN5DDwKkS0",
	"g6rK6Rmeopc",
	"oTHmCWG1qZ0",
	"sudm8iQu4OM",
	"LSH5m3Zozbg",
]



allVideos.sort(() => Math.random()-0.5)

export default 
{
	pickRandom() {
		const x = allVideos.pop()
		allVideos.unshift(x)
		return x
	}
}